export type CoolingFilterOption = {
  value: string;
  label: string;
  keywords?: string[];
};

export type CoolingFilterGroup = {
  id: string;
  label: string;
  options: CoolingFilterOption[];
};

export const coolingFilterGroups: CoolingFilterGroup[] = [
  {
    id: 'brand',
    label: 'Thương hiệu',
    options: [
      { value: 'id-cooling', label: 'ID-Cooling', keywords: ['id-cooling', 'id cooling'] },
      { value: 'deepcool', label: 'Deepcool', keywords: ['deepcool'] },
      { value: 'cooler-master', label: 'Cooler Master', keywords: ['cooler master', 'cm'] },
      { value: 'corsair', label: 'Corsair', keywords: ['corsair'] },
      { value: 'nzxt', label: 'NZXT', keywords: ['nzxt'] },
      { value: 'thermalright', label: 'Thermalright', keywords: ['thermalright'] },
      { value: 'arctic', label: 'Arctic', keywords: ['arctic'] },
      { value: 'asus', label: 'ASUS', keywords: ['asus', 'rog', 'tuf'] },
      { value: 'msi', label: 'MSI', keywords: ['msi'] },
    ],
  },
  {
    id: 'type',
    label: 'Loại tản nhiệt',
    options: [
      {
        value: 'air',
        label: 'Tản nhiệt khí',
        keywords: ['tan khi', 'air cooling', 'single tower', 'dual tower'],
      },
      {
        value: 'aio',
        label: 'Tản nhiệt nước AIO',
        keywords: ['aio', 'liquid cooling', 'all in one'],
      },
      {
        value: 'custom',
        label: 'Tản nhiệt nước Custom',
        keywords: ['custom liquid', 'tan nuoc custom'],
      },
    ],
  },
  {
    id: 'radiator-size',
    label: 'Kích cỡ Radiator (AIO)',
    options: [
      { value: '120', label: '120mm', keywords: ['120mm', '120 rad'] },
      { value: '240', label: '240mm', keywords: ['240mm', '240 rad'] },
      { value: '280', label: '280mm', keywords: ['280mm', '280 rad'] },
      { value: '360', label: '360mm', keywords: ['360mm', '360 rad'] },
      { value: '420', label: '420mm', keywords: ['420mm', '420 rad'] },
    ],
  },
  {
    id: 'fan-size',
    label: 'Kích cỡ Fan',
    options: [
      { value: '92', label: '92mm', keywords: ['92mm'] },
      { value: '120', label: '120mm', keywords: ['120mm'] },
      { value: '140', label: '140mm', keywords: ['140mm'] },
    ],
  },
];
